import firebase from "firebase/app";
import {db} from "../../../../global/services/firebase";
import {useState, useEffect} from 'react'

export const getUserProfile =async(uid)=> {

    let userProfile = {}

    await db.collection("users").doc(uid)
            .get()
            .then(function(doc) {
                if(!doc.exists || doc.data().userType === "Rejected"){
                    if(window.location.pathname !== "/account-setup"){
                        return window.location.href="/account-setup"
                    }
                }
                userProfile = doc.data()
            })
            .catch(function(error) {
                return window.location.href="/account-setup"
            });

    return userProfile
}

export const useFetchMyAccount = (event) => {

    const [state, setState] = useState({data:null,loading:true})

    useEffect(()=>{
        setState(state=>({data:state.data,loading:true}))

        async function fetchMyProfile(){
            firebase.auth().onAuthStateChanged(async function(user) {
                if(user){
                    const requestList = await getUserProfile(user.uid)
                    setState({data:requestList,loading:false})
                }
                else{
                    localStorage.clear()
                    return window.location.href="/login"
                }
            })
        }
        
        fetchMyProfile()

    },[event])

    return state
};